<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     稼动率报表
  +---------------------------------------------------------------------------------------
-->

<template>
  <div class="em-activation header-padding">
    <f-page-header />

    <div class="filter-container">
      <div class="filter-box">
        <span class="filter-item sm">
          <el-date-picker
            v-model="query.time"
            type="date"
            placeholder="选择日期"
            style="width:100%;"
            :picker-options="options"
            value-format="timestamp"
            @change="fetchData(1)"
          />
        </span>

        <span class="filter-item sm">
          <em-equip-selector v-model="query.equipid" placeholder="选择设备" @change="fetchData(1)" />
        </span>
      </div>
    </div>

    <el-card v-loading="loading" shadow="never" class="table-card">
      <el-table
        ref="listTable"
        :data="list"
        size="medium"
        class="padding-small"
        style="width: 100%"
        @selection-change="handleSelectionChange"
      >
        <el-table-column type="selection" width="60" />

        <el-table-column label="日期" min-width="120" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.datetime | parseTime('{y}-{m}-{d}') }}</span>
          </template>
        </el-table-column>

        <el-table-column label="设备" min-width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <el-link :underline="false" @click="toDetail(scope.row)">{{ scope.row.equip_name }}</el-link>
          </template>
        </el-table-column>

        <el-table-column label="关机时间(h)" min-width="120">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="round offline" />
              <span class="ml-sm number text-bold">{{ scope.row.offline_hour }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="待机时间(h)" min-width="120">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="round online" />
              <span class="ml-sm number text-bold">{{ scope.row.standby_hour }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="运行时间(h)" min-width="120">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="round running" />
              <span class="ml-sm number text-bold">{{ scope.row.running_hour }}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="故障时间(h)" min-width="120">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="round alarm" />
              <span class="ml-sm number text-bold">{{ scope.row.alarm_hour }}</span>
            </div>
          </template>
        </el-table-column>

        <el-table-column label="设备状态" align="center" min-width="280">
          <template slot-scope="scope">
            <stack-bar
              :ref="'barchart' + scope.row.random"
              :list="scope.row.equip_status"
              :random="scope.row.random"
              :show="scope.row.id > 0"
            />
          </template>
        </el-table-column>

        <el-table-column label="稼动率" min-width="100" show-overflow-tooltip>
          <template slot-scope="scope">
            <span>{{ scope.row.effectiveness }}</span>
          </template>
        </el-table-column>

        <el-table-column label="操作" align="right" width="60">
          <template slot-scope="scope">
            <el-button type="text" @click="toDetail(scope.row)">详情</el-button>
          </template>
        </el-table-column>

        <template slot="empty">
          <img class="image huger mt-lg" src="@/assets/empty.png" />
          <div class="font-md mb-hg">暂无数据</div>
        </template>
      </el-table>
    </el-card>

    <f-table-footer
      :list="list"
      :selection="multiSelection"
      @toggle="toggleAll"
      :total="total"
      :pindex.sync="query.pindex"
      :psize.sync="query.psize"
      @change="fetchData"
    >
      <template slot="left">
        <el-button class plain :disabled="total === 0" size="mini" @click="exportProcess">导出</el-button>
      </template>
    </f-table-footer>
  </div>
</template>

<script>
import {
  getActivationListApi,
  exportActivationApi,
} from "@/api/em/activationApi";

const nowDate = parseInt((new Date().getTime() / 1000).toString());
const yesterday = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24;
const last90 = nowDate - (nowDate % 86400) - 3600 * 8 - 3600 * 24 * 90;

export default {
  name: "EmActivation",

  components: {
    EmEquipSelector: () => import("@/views/em/components/EmEquipSelector"),
  },

  data() {
    var disabledDate = (date) => {
      if (this.disablerange) {
        if (this.disablerange.length === 1) {
          return date.getTime() < this.disablerange[0] * 1000;
        } else {
          return (
            date.getTime() < this.disablerange[0] * 1000 ||
            date.getTime() > this.disablerange[1] * 1000
          );
        }
      } else {
        return false;
      }
    };
    return {
      options: {
        disabledDate: disabledDate,
      },
      disablerange: [last90, yesterday],
      query: {
        time: null,
        equipid: null,
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
      },
      list: [],
      multiSelection: [],
      total: 0,
      loading: false,
    };
  },

  computed: {},

  created() {
    this.fetchData(1);
  },

  methods: {
    fetchData(page, loading = true) {
      if (page) this.query.pindex = page;
      if (loading) this.loading = true;
      const query = {
        time: this.query.time / 1000,
        equipid: this.query.equipid,
        pindex: this.query.pindex,
        psize: this.query.psize,
      };
      getActivationListApi(query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list.map((item) => {
            item.random = item.id + +new Date();
            return item;
          });
          this.total = res.data.total;
        }
      });
    },

    handleSelectionChange(val) {
      this.multiSelection = val;
    },

    toggleAll() {
      this.$refs.listTable.toggleAllSelection();
    },

    exportProcess() {
      const query = {
        time: this.query.time / 1000,
        equipid: this.query.equipid,
      };
      exportActivationApi(query).then((res) => {
        if (!res.errno) {
          window.open(res.data.url);
          this.$message.success("稼动率报表导出成功！");
        }
      });
    },

    toDetail(row) {
      const { stationid } = row;
      const _this = this;
      this.$sdetail({
        stationid,
        handleChange: () => {
          _this.fetchData();
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.em-activation {
  position: relative;
  .round {
    width: 16px;
    height: 16px;
    border-radius: 50%;
  }
  .offline {
    box-shadow: 0 0 5px #999;
    background: #999;
  }
  .online {
    box-shadow: 0 0 5px #e6a23c;
    background: #e6a23c;
  }
  .running {
    box-shadow: 0 0 5px #07c160;
    background: #07c160;
  }
  .alarm {
    box-shadow: 0 0 5px #ff776c;
    background: #ff776c;
  }
}
</style>
